import * as React from 'react';

const Eye24: React.FC<React.SVGProps<SVGSVGElement>> = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='24'
			height='24'
			viewBox='0 0 24 24'
			fill='none'>
			<path
				d='M11.999 4.5C16.6368 4.5 20.5717 7.50707 21.9619 11.6777C22.0319 11.8847 22.0319 12.1094 21.9619 12.3174C20.5758 16.4902 16.6389 19.5 11.999 19.5C7.5063 19.4998 3.67189 16.6781 2.17287 12.71L2.03518 12.3223C1.96628 12.1149 1.9662 11.8899 2.03518 11.6826C3.42228 7.51 7.35942 4.50018 11.999 4.5ZM11.999 6C8.08187 6.00018 4.74679 8.50463 3.51272 12.002C4.74937 15.4979 8.08355 17.9998 11.999 18C15.9165 18 19.2503 15.4952 20.4834 11.998C19.2465 8.50215 15.9143 6 11.999 6ZM11.999 9C12.7945 9 13.5576 9.31651 14.1201 9.87891C14.6827 10.4415 14.999 11.2044 14.999 12C14.999 12.7956 14.6827 13.5585 14.1201 14.1211C13.5575 14.6837 12.7947 15 11.999 15C11.3029 14.9999 10.6314 14.7577 10.0977 14.3203L9.87795 14.1211C9.31556 13.5585 8.99905 12.7955 8.99905 12C8.99911 11.3038 9.24131 10.6324 9.67873 10.0986L9.87795 9.87891C10.4405 9.31639 11.2035 9.00011 11.999 9ZM11.999 10.5C11.6014 10.5001 11.2197 10.6582 10.9385 10.9395C10.6573 11.2207 10.4991 11.6023 10.499 12C10.499 12.3977 10.6574 12.7793 10.9385 13.0605C11.2197 13.3418 11.6014 13.4999 11.999 13.5C12.3968 13.5 12.7783 13.3418 13.0596 13.0605C13.3409 12.7792 13.499 12.3978 13.499 12C13.499 11.6023 13.3408 11.2207 13.0596 10.9395C12.7783 10.6584 12.3967 10.5 11.999 10.5Z'
				fill='black'
			/>
		</svg>
	);
};

export default Eye24;
